import React from "react";
import { Card } from "react-bootstrap";

interface OrderInfoCardProps {
  trackingOrder: any;
}

const OrderInfoCard: React.FC<OrderInfoCardProps> = ({ trackingOrder }) => {
  if (!trackingOrder) return null;
  return (
    <Card className="mb-3">
      <Card.Body>
        <Card.Title>Pedido #{trackingOrder.sale?.number}</Card.Title>
        <ul>
          {Array.isArray(trackingOrder.sale?.status_details) &&
            trackingOrder.sale.status_details.length > 0 &&
            trackingOrder.sale.status_details.map(
              (item: any, index: number) => (
                <li key={index}>
                  <h5>{item.sale_status.name}</h5>
                  <p>
                    {new Date(item.created_at).toLocaleDateString("es-AR", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                    })}{" "}
                    {new Date(item.created_at).toLocaleTimeString("es-AR", {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </li>
              )
            )}
          {trackingOrder.sale?.traking_code && (
            <li>
              <h5>Código de segumiento</h5>
              <p>{trackingOrder.sale?.traking_code}</p>
              <p>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.correoargentino.com.ar/formularios/ondnc"
                >
                  Link Correo Argentino
                </a>
              </p>
            </li>
          )}
        </ul>
      </Card.Body>
    </Card>
  );
};

export default OrderInfoCard;
